<template>
  <div id="pest-area" style="overflow:hidden;width: 100%; height: 100%">
    <div class="pestArea-data">
      <div class="pestArea-data-head">
        <div class="pestArea-head-title">
          <span class="pestArea-head-title-Container">虫情区域统计</span>
        </div>

        <div class="pestArea-head-select">
          <div class="pestArea-head-device">
            <el-select @change="pestDeviceChange($event)" v-model="defaultPestArea" filterable>
              <el-option :key="item.deviceAddr" :label="item.deviceName" :value="item.deviceAddr" v-for="item in pestAreaList"></el-option>
            </el-select>
          </div>

          <div class="pestArea-head-time">
            <el-date-picker @change="areaSelectTime" v-model="defaultAreaTime" unlink-panels type="daterange" :picker-options="areaPickerOption" align="right"
                            end-placeholder="结束日期" key="time" range-separator="至" start-placeholder="开始日期">
            </el-date-picker>
          </div>

          <div class="pestArea-head-btn">
            <el-button type="primary" @click="areaQueryData()">查询</el-button>
            <el-button type="warning" @click="areaExportData()">导出</el-button>
          </div>
        </div>
      </div>

      <div class="pestArea-data-content" style="overflow: auto;">
        <div id="worn" class="pestArea-data-option">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment"
  import {getsysUserGroup, getWormStatisticsByGroup} from "../../until/api/SporePest";
  import {insectDevice, insectStatistic} from "../../until/api/inesctPest";
  export default {
    name: 'PestAreaData',
    components:{},
    data() {
      return {
        pestAreaList:[],
        defaultPestArea: '',
        defaultPestAreaName: '',
        defaultAreaTime: [ moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")],
        areaPickerOption: {
          shortcuts:[{
            text: '最近一天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        beginTime: '',
        endTime: '',
        wornName: [],
        wornNum: [],
        wornData: []
      }
    },

    mounted() {
      this.beginTime = moment().subtract(1, "days").format("YYYY-MM-DD"); //初期化开始时间
      this.endTime = moment().format("YYYY-MM-DD"); //初期化结束时间
      this.pestAreaDevice();
    },
    methods: {
      pestAreaDevice() {
        let token = this.$commonFun.unCompileStr(localStorage.getItem('insectToken'));
        insectDevice(token).then(response => {
          if(response.data.code == 0) {
            for(let i = 0; i < response.data.data.length; i++) {
              let jsonPest = response.data.data[i];
              this.pestAreaList.push({"deviceAddr": jsonPest.imei, "deviceName": jsonPest.devName})
            }

            if(this.pestAreaList.length > 0) {
              this.defaultPestArea = this.pestAreaList[0].deviceAddr;
              this.defaultPestAreaName = this.pestAreaList[0].deviceName;
              this.areaWormData();
            }
          }
        }).catch(error => {
          console.log("error", error);
        })
      },

      pestDeviceChange(event) {
        this.defaultPestArea = event;
        for(let i = 0; i < this.pestAreaList.length; i++) {
          if(this.defaultPestArea == this.pestAreaList[i].deviceAddr) {
            this.defaultPestAreaName = this.pestAreaList[i].deviceName;//初期化默认区域名称
          }
        }

        //清空数据
        this.wornName = [];
        this.wornNum = [];
        this.wornData = [];

        //清空柱状图
        document.getElementById("worn").removeAttribute("_echarts_instance_");
        let worn = this.$echarts.init(document.getElementById('worn'));
        worn.setOption({});
      },


      areaSelectTime(val) {
        if(val === null) { //清空时间
          this.defaultAreaTime = [moment().subtract(1, "days").format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")]; //默认显示的时间
          this.beginTime = moment().format("YYYY-MM-DD"); //默认开始时间
          this.endTime = moment().subtract(-1, "days").format("YYYY-MM-DD"); //默认结束时间
        } else { //非清空时间
          this.beginTime = moment(new Date(val[0]).getTime()).format("YYYY-MM-DD"); //选中的开始时间
          this.endTime = moment(new Date(val[1]).getTime()).format("YYYY-MM-DD"); //选中的结束时间
        }
      },

      areaQueryData() {
        this.areaWormData();//获取区域虫情数据
      },

      areaWormData() {
        //清空数据
        this.wornName = [];
        this.wornNum = [];
        this.wornData = [];

        //清空柱状图
        document.getElementById("worn").removeAttribute("_echarts_instance_");
        let worn = this.$echarts.init(document.getElementById('worn'));
        worn.setOption({});

        let token = this.$commonFun.unCompileStr(localStorage.getItem('insectToken'));
        insectStatistic(this.beginTime, this.endTime, this.defaultPestArea, token).then(response => {
          if (response.data.code == 0) {
            if(response.data.data.length > 0) {
              for(let i = 0; i < response.data.data.length; i++) {
                this.wornName.push(response.data.data[i].name);
                this.wornNum.push(response.data.data[i].value);
                this.wornData.push(response.data.data[i]);
              }
              this.$nextTick(() => {
                this.setWarnOption(); //加载折线图
              })
            } else {
              this.$message({
                showClose: true,
                type: 'warning',
                message: '所选时间段内未查询出数据'
              })
            }
          } else {
            this.$message({
              showClose: true,
              type: 'warning',
              message: '数据错误，请稍后查询'
            })
          }
        }).catch(error => {
          console.log("error", error);
        })
      },

      setWarnOption() {
        let worn = this.$echarts.init(document.getElementById('worn'));
        window.addEventListener("resize",function(){
          worn.resize()  // myChart 是实例对象
        });

        worn.setOption({
          color: ['#0FFF06',],
          title: {
            text: this.defaultPestAreaName + ' 虫情统计',
            left: 'center',
            textStyle: {
              color: '#ffffff',//#ffffff
              fontSize: 22,
              lineHeight: 30,
              fontWeight: 'normal'
            }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '2%',
            right: '5%',
            bottom: '2%',
            top: '8%',
            containLabel: true,
          },
          xAxis: {
            name: '种类',
            type: 'category',
            nameTextStyle:{
              color:'#ffffff',
              fontSize:15
            },
            boundaryGap: true,
            data: this.wornName,
            offset: 3,
            axisLabel: {
              // interval: 0,
              // rotate: -20,
              show: true,
              textStyle: {
                color: '#ffffff',
                fontSize :15,
              },
            },
            axisLine:{
              show :true,
              lineStyle:{
                color:'#ffffff'
              }
            },
            axisTick:{
              show :true,
            }
          },
          yAxis: {
            name: '数值',
            type: 'value',
            nameTextStyle:{
              color:'#ffffff',
              fontSize :15,
            },
            show: true,
            axisLabel: {
              show: true,
              textStyle: {
                color: '#ffffff'
              },
            },
            splitLine:{
              show: false,
              lineStyle: {
                color: ['#153a8a']
              }
            },
            axisLine:{
              show :true,
              lineStyle:{
                color:'rgba(231, 244, 255, 0.2)'
              }
            },
            axisTick:{
              show :false,
            },
          },
          series: [
            {
              type: 'bar',
              data: this.wornNum,
              itemStyle:{
                color:'#67e0e3',
                normal: {
                  label: {
                    show: true,
                    position: 'top',
                    textStyle: {
                      color: '#ffffff',
                      fontSize: 15
                    },
                  },
                  //color:'#67e0e3'
                  //color:function(){return "#"+Math.floor(Math.random()*(256*256*256-1)).toString(16);}
                  color: function (params) {
                    // params.dataIndex指的是每个柱状图的索引下标 分别为0 1 2 3 4 5 6 7 8 9
                    let colorArr = ["#ffa043", "#5471c8", "#934dce", "#33b6ff", "#91cc75", "#73c0de", "#4944fe", "#06e278", "#00ffff", "#1DFF41"]; //colorArr.length 为3，通过取模的方式就可以循环使用颜色了
                    return colorArr[params.dataIndex % colorArr.length];
                  },
                },
              },
              tooltip: { //提示框
                trigger: 'axis',
                axisPointer: { // 坐标轴指示器，坐标轴触发有效
                  type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                },
              },
            },
          ],
        })
      },

      areaExportData() {
        let that = this;
        if(that.wornData.length === 0) {
          that.$message({
            showClose: true,
            type: "warning",
            message: '未查询到数据',
            duration: 5000
          })
          return;
        }
        const {export_json_to_excel} = require('../../vendor/Export2Excel');
        const tHeader = ["虫种类", "虫数量"];
        const filterVal = ['name', 'value'];
        const list = that.wornData;
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, this.defaultPestAreaName + "_虫情统计");
      },

      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j=>v[j]))
      }
    }
  }
</script>

<style lang="less">
  @import "../less/PestAreaData";
</style>

<style>
  .pestArea-data-content::-webkit-scrollbar {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/PestAreaData.vue